import { getCookie, setCookie } from '../../utils/cookie';

const PLAYGROUND_COOKIE = 'dev_playground';

export function hasEnabledByPlaygroundCookie(): boolean {
	return getCookie(PLAYGROUND_COOKIE) === 'true';
}

export function togglePlaygroundCookie(on: boolean) {
	setCookie(PLAYGROUND_COOKIE, String(on), {
		days: 1,
	});
}
